import { CommonModule, Location } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PlatformNotificationFeedbackModule } from '@platform/components/platform-notification-feedback/platform-notification-feedback.module';
import type { RouterRoutes } from '@platform/types/router-route.model';
import { SkudoUiModule } from '@skudo/components/skudo-ui.module';
import { noUserGuard } from '@skudo/guards/no-user.guard';
import { ScriptInjectorsModule } from '@skudo/script-injectors/script-injectors.module';
import { SkudoAuthWrapperComponent } from './auth-wrapper.component';
import { SkudoForgotPasswordPageComponent } from './forgot-password/forgot-password.component';
import { SkudoLoginPageComponent } from './login/login.component';
import { SkudoLogoutComponent } from './logout/logout.component';
import { SkudoRecoverPasswordPageComponent } from './recover-password/recover-password.component';
import { SkudoValidateAccountComponent } from './validate-account/validate-account.component';
import { autoLoginGuardFn } from '@skudo/guards/auto-login.guard';

const routes: RouterRoutes = [
  {
    path: 'login',
    component: SkudoLoginPageComponent,
    canActivate: [autoLoginGuardFn],
  },
  { path: 'logout', component: SkudoLogoutComponent },
  {
    path: 'forgot-password',
    component: SkudoForgotPasswordPageComponent,
    canActivate: [noUserGuard],
  },
  {
    path: 'recover-password',
    component: SkudoRecoverPasswordPageComponent,
    canActivate: [noUserGuard],
  },
  {
    path: 'validate-account',
    component: SkudoValidateAccountComponent,
    canActivate: [noUserGuard],
  },
];
@NgModule({ declarations: [
        SkudoAuthWrapperComponent,
        SkudoForgotPasswordPageComponent,
        SkudoForgotPasswordPageComponent,
        SkudoLoginPageComponent,
        SkudoLogoutComponent,
        SkudoRecoverPasswordPageComponent,
        SkudoValidateAccountComponent,
    ], imports: [CommonModule,
        FormsModule,
        PlatformNotificationFeedbackModule,
        SkudoUiModule,
        ScriptInjectorsModule,
        RouterModule.forChild(routes)], providers: [Location, RouterModule, provideHttpClient(withInterceptorsFromDi())] })
export class AuthRoutingModule {}
